//
// Welcome to the annotated FaceTec Device SDK core code for performing secure Liveness Checks!
//
import { FaceTecTestingAPINetworkingRequest } from "../utilities/SampleAppNetworkingRequest";
//
// This is an example self-contained class to perform Liveness Checks with the FaceTec SDK.
// You may choose to further componentize parts of this in your own Apps based on your specific requirements.
//
var SessionRequestProcessor = /** @class */ (function () {
    function SessionRequestProcessor(demonstrationExternalDatabaseRefID, onCompleteCallback) {
        var _this = this;
        //
        // Part 2:  Handling the Result of a FaceScan
        //
        // This method gets called from inside the FaceTecSDK when some server side process is needed to continue processing
        this.onSessionRequest = function (requestBlob, requestCallback) {
            console.log('🎯 [SessionRequest] Iniciando procesamiento de sesión');
            if (window.updateStepperProgress) {
                var currentPath = window.location.pathname.toLowerCase();
                var isEnroll = currentPath.includes('enroll');
                window.updateStepperProgress(isEnroll ? 3 : 2);
            }
            // Create the simple payload to send to the networking class
            var sessionRequestProcessorPayload = {
                requestBlob: requestBlob,
            };
            if (_this.demonstrationExternalDatabaseRefID !== "") {
                sessionRequestProcessorPayload.externalDatabaseRefID = _this.demonstrationExternalDatabaseRefID;
            }
            console.log('📋 [SessionRequest] Payload preparado:', {
                hasExternalDatabaseRefID: !!_this.demonstrationExternalDatabaseRefID,
                requestBlobLength: requestBlob.length
            });
            // demonstrationExternalDatabaseRefID is included in FaceTec Device SDK Sample App Code for demonstration purposes.
            // In Your App, you will be setting and handling this in Your Webservice code.
            new FaceTecTestingAPINetworkingRequest().send(sessionRequestProcessorPayload, requestCallback);
        };
        // Session is completely done
        this.onFaceTecExit = function (faceTecSessionResult) {
            console.log('🏁 [SessionRequest] Sesión completada');
            console.log('📊 [SessionRequest] Status:', faceTecSessionResult.status);
            console.log('📄 [SessionRequest] Resultado completo:', faceTecSessionResult);
            _this.onCompleteCallback(faceTecSessionResult.status);
        };
        this.demonstrationExternalDatabaseRefID = demonstrationExternalDatabaseRefID;
        this.onCompleteCallback = onCompleteCallback;
    }
    return SessionRequestProcessor;
}());
export { SessionRequestProcessor };
